import { defineEntity, custom } from './_helpers.js';

export default defineEntity('dataBreach', {
    deadlineReminder: custom({ scope: 'state' }),
    deadlineOverdue: custom({ scope: 'state' }),
    dataSubjectDeadlineReminder: custom({ scope: 'state' }),
    dataSubjectDeadlineOverdue: custom({ scope: 'state' }),
});
